module.exports = __webpack_public_path__ + "img/sunset-2.bd3bdaac.jpeg";